import { useEffect, useState } from "react";
import api, { num, money } from "@/lib/api";
import { Card, PageHeader, StatusBadge, EmptyState, KPICard, Th, Td } from "@/components/admin/ui";

export default function Sales() {
  const [data, setData] = useState({ items: [], total: 0 });
  useEffect(() => { api.get("/sales?limit=50").then((r) => setData(r.data)).catch(() => {}); }, []);
  const totalRev = data.items.reduce((a, s) => a + (s.normalized_value || 0), 0);
  return (
    <div className="space-y-6">
      <PageHeader title="Sales" subtitle={`${num(data.total)} closed deals`} />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <KPICard label="Total Sales" value={num(data.total)} />
        <KPICard label="Revenue (page)" value={money(totalRev)} accent="#10B981" />
        <KPICard label="Avg Deal" value={money(data.items.length ? totalRev / data.items.length : 0)} accent="#06B6D4" />
      </div>
      <Card>
        {data.items.length === 0 ? <EmptyState title="No sales yet" desc="Closed deals recorded by workers will appear here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="border-b border-white/10"><tr><Th>Sale ID</Th><Th>Worker</Th><Th>Deal Value</Th><Th>Currency</Th><Th>Normalized (INR)</Th><Th>Status</Th></tr></thead>
              <tbody>
                {data.items.map((s) => (
                  <tr key={s.id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`sale-row-${s.sale_id}`}>
                    <Td className="font-mono-metric text-[#1D4ED8]">{s.sale_id}</Td>
                    <Td className="text-slate-400">{s.worker_id}</Td>
                    <Td className="text-white font-medium font-mono-metric">{num(s.deal_value)}</Td>
                    <Td>{s.currency}</Td>
                    <Td className="font-mono-metric text-emerald-400">{money(s.normalized_value)}</Td>
                    <Td><StatusBadge status={s.status} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
